// =============================================================================
// Firebase initialization.
//
// The web config below is read from Vite env vars (see .env.example). These
// values are NOT secret — Firebase web config is safe to expose; access is
// governed by Firestore security rules and Auth, not by hiding the keys.
// Sensible defaults for the `lairo-status` project are filled in where the
// value is derivable; override anything via a local .env file.
// =============================================================================
import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const env = import.meta.env;

const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || "lairo-status.firebaseapp.com",
  projectId: env.VITE_FIREBASE_PROJECT_ID || "lairo-status",
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || "lairo-status.appspot.com",
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });
